<div class="modal-header py-2 inset-box-shadow">
  <h4 class="m-0 align-self-end">{{selectedSpell? 'Edit Spell' : 'New Spell'}}</h4>
  <button type="button" class="close" aria-label="Close"
          (click)="activeModal.dismiss('cancel')" id="closeModalBtn">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body custom-scrollbar">
  <form [formGroup]="spellForm">
    <div class="d-flex">
      <div class="mb-3 mr-2 col-6">
        <label>Spell Name</label>
        <input formControlName="name" type="text" class="form-control" ngbAutofocus>
      </div>
      <div class="d-flex flex-column mb-3 mr-4" style="width: 10%">
        <label>Level</label>
        <div class="btn-group">
          <input formControlName="level" type="text" class="form-control dropdown-input" id="level-input">
          <div class="btn-group" ngbDropdown role="group" aria-label="Level">
            <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button *ngFor="let level of levels" ngbDropdownItem (click)="selectLvl(level)">
                {{level === '0' ? 'Cantrip' : 'Level ' + level}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column mb-3">
        <label>School</label>
        <div class="btn-group">
          <input formControlName="school" type="text" class="form-control dropdown-input" id="school-input">
          <div class="btn-group" ngbDropdown role="group" aria-label="Level" placement="bottom-right">
            <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button *ngFor="let school of schools" ngbDropdownItem (click)="selectSchool(school)">
                {{school}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex" style="width: 65%">
      <div class="mb-3 col-6">
        <label>Casting Time</label>
        <input formControlName="castingTime" type="text" class="form-control">
      </div>
      <div class="mb-3 col-6">
        <label>Range</label>
        <input formControlName="range" type="text" class="form-control">
      </div>
      <div class="mb-3 col-6">
        <label>Duration</label>
        <input formControlName="duration" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group ml-3 mr-3">
      <label>Description</label>
      <textarea id="description" rows="3" type="text-area" class="form-control" formControlName="description">
        </textarea>
    </div>
  </form>
</div>

<div class="modal-footer d-flex justify-content-between py-2">
  <button *ngIf="selectedSpell" (click)="delete()"
          class="btn btn-sm btn-danger ml-4" id="deleteButton" type="button">Delete
  </button>
  <div *ngIf="!selectedSpell"></div>
  <div class="mr-4">
    <button (click)="activeModal.close('cancel')" class="btn btn-sm btn-outline-secondary mr-2"
            id="cancelButton" type="button">Cancel
    </button>
    <button (click)="activeModal.close(save())" class="btn btn-sm btn-success" id="saveButton"
            [disabled]="!areChanges">{{selectedSpell ? 'Save' : 'Add Spell'}}
    </button>
  </div>
</div>
